import { useEffect } from "react";
const apiUrl = import.meta.env.VITE_API_URL;
export default function StartPage() {
  useEffect(() => {
    // Get the current URL
    const url = new URL(window.location.href);

    // Extract query parameters
    const params = new URLSearchParams(url.search);
    const planId = params.get("plan_id");
    const isAnnual = params.get("is_annual") === "true";

    console.log("Plan ID:", planId);
    console.log("Is Annual:", isAnnual);

    // Store the plan selection in localStorage if parameters exist
    if (planId) {
      localStorage.setItem("selected_plan_id", planId);
    } else {
      window.location.href = `${import.meta.env.VITE_FRONTEND_URL}`;
    }

    if (isAnnual !== null) {
      localStorage.setItem("selected_plan_annual", isAnnual.toString());
    } else {
      window.location.href = `${import.meta.env.VITE_FRONTEND_URL}`;
    }

    window.location.href = `${apiUrl}/api/auth/google`;
  }, []);
  return <div>StartPage</div>;
}
